import {
  ADD_APPOINTMENTS,
  ADD_APPOINTMENTS_FAILURE,
  ADD_APPOINTMENTS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const addAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APPOINTMENTS:
      return { ...state, loading: true };
    case ADD_APPOINTMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ADD_APPOINTMENTS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default addAppointmentsReducer;
